<template>
  <svg
    width="33"
    height="31"
    viewBox="0 0 33 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5466 1.01365C15.8412 0.0824909 17.1588 0.0824881 17.4534 1.01364L20.4326 10.4303C20.5641 10.8461 20.9499 11.1287 21.386 11.1287H31.0822C32.0445 11.1287 32.4515 12.3547 31.6803 12.9301L23.7904 18.8174C23.4492 19.072 23.3066 19.5147 23.435 19.9205L26.4378 29.4119C26.7307 30.338 25.6647 31.0959 24.8863 30.515L17.098 24.7036C16.7433 24.4389 16.2567 24.4389 15.902 24.7036L8.11369 30.515C7.33526 31.0959 6.26927 30.338 6.56223 29.4119L9.56502 19.9205C9.69342 19.5147 9.55081 19.072 9.20963 18.8174L1.31971 12.9301C0.548494 12.3547 0.955497 11.1287 1.91775 11.1287H11.614C12.0501 11.1287 12.4359 10.8461 12.5674 10.4303L15.5466 1.01365Z"
      fill="#F9D453"
    />
  </svg>
</template>
